/**
 * Lazy-loads Shopify's native Product Recommendations endpoint and swaps
 * in the returned markup. See sections/recommendations.liquid.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    var url = el.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('.recommendations');
        if (content && content.innerHTML.trim()) {
          el.innerHTML = content.innerHTML;
          el.removeAttribute('data-recommendations');
          // Las product-card recien inyectadas no tienen su carousel/quick-add
          // enganchados todavia — product-card-carousel.js ya corrio antes de
          // que existieran. Avisarle para que las inicialice.
          document.dispatchEvent(new CustomEvent('vv:products-loaded'));
        } else {
          el.remove();
        }
      })
      .catch(function () { el.remove(); });
  });
})();
